import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import RequestAdminLocalPW from 'widgets/RequestAdminLocalPW';
import { verifyAdminPW } from 'widgets/RequestAdminLocalPW/Callback';
import { IStaffItemData } from 'services/shop/types/staff';
import PartialVoidModal from './PartialVoidModal';
import ticketListSelectors from 'features/ticketList/services/selectors';

type Props = {};

type Ref = {
  open: (partialVoid: boolean) => void;
};

export const usePartialVoidButtonRef = () => useRef<Ref>(null);

const PartialVoidButtonHandler = forwardRef<Ref, Props>((_, ref) => {
  const ticketDetails = ticketListSelectors.ticketDetailsData.data();
  const [partialVoid, setPartialVoid] = useState(false);
  const [adminVerify, setAdminVerify] = useState<IStaffItemData | undefined | null>(null);
  const [visiblePW, setVisiblePW] = useState(false);

  const [openPartialVoidModal, setOpenPartialVoidModal] = useState(false);

  const callbackOpen = (staff?: IStaffItemData | null) => {
    setAdminVerify(staff || null);
    setOpenPartialVoidModal(true);
  };

  const handleShowModal = async () => {
    verifyAdminPW((_pin, staff) => {
      callbackOpen(staff);
    });
  };

  const onVerifyAdminSuccess = () => {
    setVisiblePW(false);
    setOpenPartialVoidModal(true);
  };

  useImperativeHandle(ref, () => ({
    open: (partialVoid: boolean) => {
      setPartialVoid(partialVoid);
      handleShowModal();
    },
  }));

  if (!ticketDetails) return null;

  return (
    <>
      {visiblePW && (
        <RequestAdminLocalPW
          onlyAdmin
          visible
          v2
          onCorrect={onVerifyAdminSuccess}
          onClose={() => setVisiblePW(false)}
        />
      )}
      <PartialVoidModal visible={openPartialVoidModal} onClose={() => setOpenPartialVoidModal(false)} staffId={adminVerify?.id} partialVoid={partialVoid} />

    </>
  );
});
PartialVoidButtonHandler.displayName = 'PartialVoidButtonHandler';
export default PartialVoidButtonHandler;

